import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { get, map } from "lodash";
import { withTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { listSurvey, horizontalList, verticalList } from "store/actions";
import checkType from "helpers/jwt-token-access/checkType";
//i18n
import i18n from "../../../i18n";
import { fetchLanguageList } from "helpers/backend_api_helper";

const LanguageDropdown = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  let location = useLocation();
  // Declare a new state variable, which we'll call "menu"
  const [languageList, setLanguageList] = useState()
  const [selectedLang, setSelectedLang] = useState("");
  const [menu, setMenu] = useState(false);
  console.log("location", location.pathname)
  useEffect(() => {
    const currentLanguage = localStorage.getItem("I18N_LANGUAGE");
    setSelectedLang(currentLanguage);
  }, [])

  const changeLanguageAction = (lang, data) => {
    //set language as i18n
    i18n.changeLanguage(lang);
    localStorage.setItem("I18N_LANGUAGE", lang);
    localStorage.setItem("language_id", data?.id);
    setSelectedLang(lang);
    // window.location.href = '/dashboard'
    // navigate('/dashboard')
    
    if (checkType() == "rater") {

      if (location.pathname == "/complete-self-servey/phase-one") {

        dispatch(listSurvey("rater"));

      } else if (location.pathname == "/complete-self-servey/phase-two") {

        dispatch(listSurvey("rater"));
        dispatch(horizontalList());
        dispatch(verticalList());

      } else if (location.pathname == "/complete-self-servey/phase-three") {

        dispatch(listSurvey("rater"));

      } else if (location.pathname == "/complete-self-servey/phase-four") {

        dispatch(listSurvey("rater"));

      } else if (location.pathname == "/complete-self-servey/phase-five") {
        
        dispatch(listSurvey("rater"));
      }

    }

    if (checkType() == "participant") {

      if (location.pathname == "/complete-self-servey/phase-one") {

        dispatch(listSurvey("participant"));

      } else if (location.pathname == "/complete-self-servey/phase-two") {

        dispatch(listSurvey("participant"));
        dispatch(horizontalList());
        dispatch(verticalList());

      } else if (location.pathname == "/complete-self-servey/phase-three") {

        dispatch(listSurvey("participant"));

      } else if (location.pathname == "/complete-self-servey/phase-four") {

        dispatch(listSurvey("participant"));

      } else if (location.pathname == "/complete-self-servey/phase-five") {

        dispatch(listSurvey("participant"));
      }



    }

  }


  const toggle = () => {
    setMenu(!menu);
  }

  const fetchLanguageLists = async () => {
    const listLang = await fetchLanguageList();
    setLanguageList(listLang?.data)
  }

  useEffect(() => {
    fetchLanguageLists()
  }, [])

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block header-lang-choose-btn">
        <DropdownToggle className="btn header-item lang-button" tag="button">
          {/* <img
            src={get(languages, `${selectedLang}.flag`)}
            alt="Schor"
            height="16"
            className="me-1"
          /> */}
          <span className="align-middle">
            {/* {selectedLang} */}
            {selectedLang === "EN" ? "English" :
              selectedLang === "FR" ? "French" :
                selectedLang === "IU" ? "Inuktitut" :
                  selectedLang === "ES" ? "Spanish" :
                    selectedLang === "AR" ? "Arabic" :
                      selectedLang === "DE" ? "German" :
                        "Kurdish"
            }
          </span>
        </DropdownToggle>
        <DropdownMenu className="language-switch dropdown-menu-end">
          {
            languageList?.map((data) => {
              return (
                <DropdownItem
                  key={data?.code}
                  onClick={() => changeLanguageAction(data?.code, data)}
                  className={`notify-item ${selectedLang === data?.code ? "active" : "none"}`}
                >
                  <span className="align-middle">
                    {data?.label}
                  </span>
                </DropdownItem>
              )
            })
          }
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

export default withTranslation()(LanguageDropdown)
